import { useEffect, useState } from "react";
import { getDatasetList, downloadDataset, createDataset } from "../assets/constants/global_apis";
import SearchMenu from "../components/SearchMenu";
import { FilesInfo } from "../components/FilesInfo";
import AlertPopup, { triggerAlert } from "../components/AlertMessage";
import FolderZipIcon from '@mui/icons-material/FolderZip';
import '../assets/styles/datasets_models.css'
import CircularProgress from '@mui/material/CircularProgress';


export default function Datasets() {
    const [datasets, setDatasets] = useState([]);
    const [initialDatasets, setInitialDatasets] = useState([]);
    const [selectedDataset, setSelectedDataset] = useState({});
    const [selectedDatasetId, setSelectedDatasetId] = useState(-1);
    const [showDatasetView, setShowDatasetView] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [formFields, setFormFields] = useState({
        "title": "Dataset",
        "fields": [
            { "label": "Dataset Type", "name": "dataset_type", "type": "text", "required": true },
            { "label": "Dataset Name", "name": "dataset_name", "type": "text", "required": true },
            { "label": "Description", "name": "dataset_description", "type": "textarea", "required": false },
            // { "label": "Created By", "name": "created_by", "type": "text", "required": true },
            { "label": "Dataset Meta", "name": "dataset_meta", "type": "json", "required": false },
            { "label": "Upload File", "name": "file", "type": "file", "required": true }
        ]
    });

    const handleModalClose = () => {
        setOpenModal(false);
    }
    const handleModalOpen = () => {
        setOpenModal(true);
    }

    const geAlldatasetsList = () => {
        getDatasetList()
            .then(data => {
                if (data && data?.length > 0) {
                    setInitialDatasets(data);
                    setDatasets(data.map(dataset => ({
                        ...dataset,
                        label: dataset.dataset_name,
                        id: dataset.dataset_id,
                        last_timestamp: dataset.created_date_time
                    })));
                }
            })
    }


    const handleDatasetDownload = (dataset_id) => {
        setDownloadLoading(true)
        downloadDataset(dataset_id).then(() => {
            console.log(`Downloading dataset ${dataset_id}`);
            setDownloadLoading(false)
        }).catch((e) => {
            triggerAlert('error', e.message);
            setDownloadLoading(false)
        })
    }


    const filterDatasets = (e) => {
        if (e.target.value !== "") {
            let filteredDatasets = initialDatasets.filter((dataset) => dataset.dataset_name.toLowerCase().includes(e.target.value.toLowerCase()));
            setDatasets(filteredDatasets.map(dataset => ({
                ...dataset,
                label: dataset.dataset_name,
                id: dataset.dataset_id,
                last_timestamp: dataset.created_date_time
            })));
        } else {
            geAlldatasetsList();
        }
    }
    useEffect(() => {
        geAlldatasetsList();
    }, [])

    const handleDatasetClick = (element, index) => {
        const { ...filteredObject } = element;
        setSelectedDatasetId(element.dataset_id);
        setSelectedDataset(filteredObject);
        setShowDatasetView(true)
    }

    const onSubmit = async (formData) => {
        createDataset(formData).then(() => {
            triggerAlert('success', 'Dataset added successfully');
            getDatasetList();
            handleModalClose();
        }).catch((e) => {
            triggerAlert('error', e.message);
            handleModalClose();
        })
    };

    return (
        <div className="container-fluid g-2 datasets-tab-container">
            <AlertPopup />
            <div className="row g-2">
                <SearchMenu
                    filterFunction={filterDatasets}
                    ElementList={datasets}
                    handleOnClickItem={handleDatasetClick}
                    selectedItem={selectedDataset}
                    buttonAction='Create New'
                    title="Dataset"
                    isDeleteNotRequired={true}
                    customMenuIcon={<FolderZipIcon className="custom-menu-icon" />}
                    handleModalOpen={handleModalOpen}
                    handleCloseModal={handleModalClose}
                    open={openModal}
                    handleSubmitConfirmation={handleModalClose}
                    errors={errors}
                    onSubmit={onSubmit}
                    formFields={formFields}
                    setFormFields={setFormFields}
                />
                <div className="col-md-9">
                    {showDatasetView &&
                        <div className='agent-details-container'>
                            <div className="dataset-header-continer d-flex p-2 justify-content-start align-items-center">
                                <button className="btn btn-dark download-button" style={{ marginLeft: '1%' }}
                                    onClick={() => handleDatasetDownload(selectedDataset.dataset_id)}
                                    disabled={downloadLoading}
                                >
                                    {downloadLoading ?<>Downloading <CircularProgress color="white" style={{
                                    width:"18px",
                                    height:'18px'
                                   }}  /> </> : <><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 me-2">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                                    </svg>
                                   Download Dataset</>} 
                                </button>
                                
                            </div>
                            <FilesInfo
                                selectedFileInfo={selectedDataset}
                                numberType=''
                            />
                        </div>
                    }
                </div>
            </div>
        </div>
    );
};
